import Cookies from "js-cookie";
import EnvironmentService from "./environmentService";

export default class SprintService {

    constructor() {
        this.environmentService = new EnvironmentService();
    }

    async retrieveOpenSprints(projectUUID) {

        const queryString = "?projectUUID=" + encodeURIComponent(projectUUID);

        let result = await fetch(this.environmentService.getEnvironmentHost() + "/api/Sprint/Active" + queryString,
            {
                headers:
                {
                    "Authorization": "Bearer " + Cookies.get("access_token")
                }
            });
        let responseOK = result && result.ok;
        if (responseOK) {
            let data = await result.json();
            return data;
        }
        else {
            return result;
        }

    }

    async retrieveAllSprints(projectUUID) {
        const queryString = "?projectUUID=" + encodeURIComponent(projectUUID);

        let result = await fetch(this.environmentService.getEnvironmentHost() + "/api/Sprint/All" + queryString,
            {
                headers:
                {
                    "Authorization": "Bearer " + Cookies.get("access_token")
                }
            });
        let responseOK = result && result.ok;
        if (responseOK) {
            let data = await result.json();
            return data;
        }
        else {
            return result;
        }

    }

    async createNewSprint(projectUUID, sprintName) {
        const queryString = "?projectUUID=" + encodeURIComponent(projectUUID) + "&SprintName=" + encodeURIComponent(sprintName);

        let result = await fetch(this.environmentService.getEnvironmentHost() + "/api/Sprint" + queryString,
            {
                headers:
                {
                    "Authorization": "Bearer " + Cookies.get("access_token")
                },
                method: "POST"
            });
        let responseOK = result && result.ok;
        if (responseOK) {
            let data = await result.json();
            return data;
        }
        else {
            return result;
        }
    }

    async getSprintInDetail(sprintUUID) {
        const queryString = "?sprintUUID=" + encodeURIComponent(sprintUUID);

        let result = await fetch(this.environmentService.getEnvironmentHost() + "/api/Sprint" + queryString,
            {
                headers:
                {
                    "Authorization": "Bearer " + Cookies.get("access_token")
                }
            });
        let responseOK = result && result.ok;
        if (responseOK) {
            let data = await result.json();
            return data;
        }
        else {
            return result;
        }
    }

    async updateSprintStatus(sprintUUID, sprintStatus) {
        const queryString = "?sprintUUID=" + encodeURIComponent(sprintUUID) + "&sprintStatus=" + encodeURIComponent(sprintStatus);

        let result = await fetch(this.environmentService.getEnvironmentHost() + "/api/Sprint/Status" + queryString,
            {
                headers:
                {
                    "Authorization": "Bearer " + Cookies.get("access_token")
                },
                method: "PUT"
            });
        let responseOK = result && result.ok;
        if (responseOK) {
            let data = await result.json();
            return data;
        }
        else {
            return result;
        }
    }

    async addTasksToSprint(sprintUUID, taskUUIDs) {
        let sprintUpdateObject = {
            Tasks: taskUUIDs
        };

        const queryString = "?sprintUUID=" + encodeURIComponent(sprintUUID);

        let result = await fetch(this.environmentService.getEnvironmentHost() + "/api/Sprint/Tasks" + queryString,
            {
                headers:
                {
                    "Authorization": "Bearer " + Cookies.get("access_token"),
                    "Content-type": "application/json"
                },
                method: "POST",
                body: JSON.stringify(sprintUpdateObject)
            });
        let responseOK = result && result.ok;
        if (responseOK) {
            let data = await result.json();
            return data;
        }
        else {
            return result;
        }
    }

    async removeTasksFromSprint(sprintUUID, taskUUIDs) {
        let sprintUpdateObject = {
            Tasks: taskUUIDs
        };

        const queryString = "?sprintUUID=" + encodeURIComponent(sprintUUID);

        let result = await fetch(this.environmentService.getEnvironmentHost() + "/api/Sprint/Tasks" + queryString,
            {
                headers:
                {
                    "Authorization": "Bearer " + Cookies.get("access_token"),
                    "Content-type": "application/json"
                },
                method: "DELETE",
                body: JSON.stringify(sprintUpdateObject)
            });
        let responseOK = result && result.ok;
        if (responseOK) {
            let data = await result.json();
            return data;
        }
        else {
            return result;
        }
    }

    async transferTasksFromSprint(oldSprintUUID, newSprintUUID) {
        const queryString = "?oldSprintUUID=" + encodeURIComponent(oldSprintUUID) + "&newSprintUUID=" + encodeURIComponent(newSprintUUID);
        let result = await fetch(this.environmentService.getEnvironmentHost() + "/api/Sprint/Transfer" + queryString,
            {
                headers:
                {
                    "Authorization": "Bearer " + Cookies.get("access_token")
                },
                method: "PUT"
            });
        let responseOK = result && result.ok;
        if (responseOK) {
            let data = await result.json();
            return data;
        }
        else {
            return result;
        }
    }
}


// WEBPACK FOOTER //
// ./src/service/sprintService.js